module.exports = __webpack_public_path__ + "images/computer-icon-e50d72374b7af499e1cfb8f42a094b6f.svg";